export class Logger {
  category: string = '';
  storage = localStorage.getItem('debug');

  constructor(category: string) {
    this.category = category;
  }

  get isEnabled(): boolean {
    return this.category === this.storage || this.storage === 'all';
  }

  format(message: string): string {
    const prefix = this.category ? `[${this.category}]` : '';
    return `${prefix} ${message}`;
  }

  info(message: string, trace?: unknown): void {
    this.isEnabled &&
    console.info(this.format(message), trace || '');
  }

  warn(message: string, trace?: unknown): void {
    this.isEnabled &&
    console.warn(this.format(message), trace || '');
  }

  error(message: string, trace?: unknown): void {
    this.isEnabled &&
    console.error(this.format(message), trace || '');
  }
}
